import { isEqual } from "lodash";
import { Counter } from "PFApp/components/counter";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { getValueFilters } from "../../../use_filtered_collection/format_filters";
import css from "./counters.module.scss";
import useApprovalsCounters from "./use_approvals_counters";

type ICounter = {
  name: string;
  code: string;
  separator?: boolean;
  filter: { state?: "approved" | "rejected" | "pending" };
  counter: number | null;
};

type IProps = {
  onFilterChange: (i: object, j: string | undefined) => void;
  meta: {
    filters: { fields: any; numbers: any; availability: any; strings: any };
    total?: number;
  };
  onChange?: () => void;
};

const Counters = ({ onFilterChange, meta, onChange }: IProps) => {
  const { t } = useTranslation(["bookingModule", "translation"]);
  const { current: initialCounters } = useRef<ICounter[]>([
    { name: t("translation:total"), code: "total", filter: {}, separator: true, counter: meta.total || 0 },
    {
      name: t("bookingModule:approvals.status.pending"),
      code: "pending",
      filter: { state: "pending" },
      separator: true,
      counter: null
    },
    {
      name: t("bookingModule:approvals.status.approved"),
      code: "approved",
      filter: { state: "approved" },
      separator: true,
      counter: null
    },
    {
      name: t("bookingModule:approvals.status.rejected"),
      code: "rejected",
      filter: { state: "rejected" },
      counter: null
    }
  ]);
  const [counters, setCounters] = useState<ICounter[]>(initialCounters);

  const newSelectedFilters = getValueFilters(meta.filters);
  delete newSelectedFilters?.fields?.state;
  const [selectedFilters, setSelectedFilters] = useState(newSelectedFilters);

  useEffect(() => {
    if (!isEqual(selectedFilters, newSelectedFilters)) {
      setSelectedFilters(newSelectedFilters);
    }
  }, [meta]);

  const statusFilter = meta.filters?.fields?.state;
  const activeCounter = statusFilter?.value?.[0];

  const approvalsCounters = useApprovalsCounters(selectedFilters);

  useEffect(() => {
    setCounters(initialCounters.map((counter) => ({ ...counter, counter: approvalsCounters[counter.code] })));
  }, [approvalsCounters]);

  return (
    <div className={css.scrollWrapper}>
      <div className={css.counters}>
        {counters.map(({ name, code, separator, counter, filter }) => (
          <React.Fragment key={`${code}_${JSON.stringify(selectedFilters)}`}>
            <Counter
              title={name}
              code={code}
              selected={activeCounter === filter.state}
              counter={counter}
              onClick={() => {
                onFilterChange({ name: "state" }, filter.state);
                onChange && onChange();
              }}
              qaIdPrefix={`BookingPageApprovalsCounter_${name}`}
            />
            {separator && <div className={css.separator} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Counters;
